import { useStores } from 'hooks';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { getRouteFromPathName } from '../../../../../shared/utils/localStorage';
import { storageKeys } from '../../../../../stores/DebuggerStore';
import { CloseContainer } from '../Styles';

export const CloseViewerButton = observer(() => {
  const {
    DebuggerStore: { removeDebugArrayItem, setUpdated },
  } = useStores();

  return (
    <CloseContainer
      onClick={() => {
        const slug = getRouteFromPathName()?.toLowerCase();
        removeDebugArrayItem(storageKeys.showViewer, slug);
        setUpdated();
      }}
    >
      <i aria-hidden="true" className="fa fa-times" />
    </CloseContainer>
  );
});

export default CloseViewerButton;
